// extracted by mini-css-extract-plugin
export var header = "Header-module--header--AWpe5";
export var fixedHeader = "Header-module--fixed-header--1MJ5Y";
export var logo = "Header-module--logo--2EZVS";
export var wrapper = "Header-module--wrapper--7g-D7";
export var buttons = "Header-module--buttons--1zh0j";